import axios from "axios";
import { Message } from "element-ui";
import store from "@/store";
// import { getToken } from "@/utils/auth";
// let apiUrl ="https://testpingjia.67286728.com/testapp";//外网测试 实际用
let apiUrl ="https://pingjia.67286728.com/app";//外网生产 实际用
// 创建axios实例process.env.VUE_APP_BASE_API
const service = axios.create({
  // baseURL: "https://testpingjia.67286728.com/testapp", // 外网 外网测试 实际用
  baseURL: "https://pingjia.67286728.com/app", // 外网 外网生产 实际用
  timeout: 30000, //请求超时
});
// 请求拦截器
service.interceptors.request.use(
  // (config) => {
  //   const token = getToken();
  //   if (token) {
  //     config.headers["auth-token"] = token;
  //   }
  //   return config;
  // },
  // (error) => {
  //   return Promise.reject(error);
  // }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    return res;
    //判断token是否过期
    // if (res.code === 1 && res.message === "用户未登录") {
    //   store.dispatch("user/resetToken").then(() => {
    //     Message({
    //       message: "登录过期，请重新登录。",
    //       type: "error",
    //       duration: 1000,
    //     });
    //     //修复token超时导航栏不正确的bug
    //     setTimeout(() => {
    //       location.reload();
    //     }, 1000);
    //   });
    // }
    // // 如果定制代码不是0，则判定为错误。
    // if (res.code != 0) {
    //   Message({
    //     message: res.message || "Error",
    //     type: "error",
    //     duration: 5 * 1000,
    //   });
    // } else {
    //   return res;
    // }
  },
  (error) => {
    console.log("err" + error); // for debug
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);
export default service;

export function getUrl() {
  return apiUrl
}

